import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _find from 'lodash/find';

//utils
import queries from '../../../utils/queries'

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.claseserv._id} value={props.elemento._id} style={props.styles.input}>{props.elemento.claseserv.codigoClaseServ}: {props.elemento.claseserv.descrClaseServ} ={">"} {props.elemento.codigoSubclaseServ}: {props.elemento.descrSubclaseServ}</option>
  )
};

const Lista = ({styles, handleLista, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="subclase" id="miLista" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        
        {Nivel1Detalle}
       </select>
    </div>
  )
};

const DetalleNivelTT = props => {
  return (
    <option dato1={props.elemento.descrTipoTec} value={props.elemento.codigoTipoTec} style={props.styles.input}>{props.elemento.codigoTipoTec} ={">"} {props.elemento.descrTipoTec}</option>
  )
};

const ListaTT = ({styles, handleLista, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelTT styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tipotec" id="miListaTT" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        
        {Nivel1Detalle}
       </select>
    </div>
  )
};

const ListaDXMas = ({handleLista7}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista7" id="miLista7" onChange={handleLista7}>
        <option>Seleccionar...</option>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

class AddServicio2 extends React.Component{
// const AddServicio2 = ({styles, handleLista, handleLista7, handleSubmit, handleChange,
//                   args, errors, data: {allSubclasesServ=[], allTipoTec=[]}}) => {
// const AddServicio2 = ({styles, handleLista, handleSubmit, handleChange, args, errors}) => {

  render(){
    let listSC = [], listTT = []
    if(this.props.allSubclasesServ.allSubclasesServ){listSC = this.props.allSubclasesServ.allSubclasesServ}
    if(this.props.allTipoTec.allTipoTec){listTT = this.props.allTipoTec.allTipoTec}
    // let listSC = this.props.allSubclasesServ.allSubclasesServ
    // let listTT = this.props.allTipoTec.allTipoTec
    // console.log(this.props.args)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Servicio nuevo
        </button>
        <div style={this.props.styles.box}>
          <Form onSubmit={(ev)=>this.props.handleSubmit(ev, this.props.args)}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Código</label>
                          <input style={this.props.styles.input} autoComplete="off" name="codigoServicio" id="codigoServicio" onChange={this.props.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoServicio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Descripción resumida</label>
                          <input style={this.props.styles.input} autoComplete="off" name="nombreResumido" id="nombreResumido" onChange={this.props.handleChange} placeholder='Descripción resumida' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreResumido'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <input style={this.props.styles.input} autoComplete="off" name="descripcionServicio" id="descripcionServicio" onChange={this.props.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descripcionServicio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Concepto en factura</label>
                          <input style={this.props.styles.input} autoComplete="off" name="conceptoEnFra" id="conceptoEnFra" onChange={this.props.handleChange} placeholder='Concepto en factura' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'conceptoEnFra'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Consecutivo en factura</label>
                          <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="consecEnFra" id="consecEnFra" placeholder='Consecutivo en factura' onChange={this.props.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                  <Form.Field>
                    <label style={this.props.styles.label}>Subclase</label>
                    <Lista list={listSC} styles={this.props.styles} handleLista={this.props.handleLista} />
                  </Form.Field>

                  <div className="ui three column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '25%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Velocidad efectiva Downstream</label>
                          <input type='number' step="0.1" min="0" style={this.props.styles.input} autoComplete="off" name="velEfecDownstream" id="velEfecDownstream" placeholder='Velocidad efectiva Downstream' onChange={this.props.handleChange}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '25%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Velocidad efectiva Upstream</label>
                          <input type='number' step="0.1" min="0" style={this.props.styles.input} autoComplete="off" name="velEfecUpstream" id="velEfecUpstream" placeholder='Velocidad efectiva Upstream' onChange={this.props.handleChange}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Tipo de Tecnología</label>
                          <ListaTT list={listTT} styles={this.props.styles} handleLista={this.props.handleLista1} />
                        </Form.Field>
                      </div>
                    </div>
                  </div>

                  <Form.Field>
                    <label style={this.props.styles.label}>Color para distinguir en Clientes</label>
                    <input style={{width: '25%'}} type='color' value={this.props.args.colorServicio?this.props.args.colorServicio:"#ffffff"} name="colorServicio" id="colorServicio" onChange={this.props.handleChange}/>
                  </Form.Field>

                  <Form.Field>
                    <label style={this.props.styles.label}>Seleccionar en proceso de DX masivas:</label>
                    <ListaDXMas styles={this.props.styles} handleLista7={this.props.handleLista7} />
                  </Form.Field>

                  <Button style={this.props.styles.confirmar} type='submit' fluid>
                    AGREGAR
                  </Button>

                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

// export default AddServicio2
// export default graphql(queries.query.allSubclasesServ, {options: (props) => {return {variables: {}}}})(AddServicio2)

export default compose(
  graphql(queries.query.allSubclasesServ, {name:'allSubclasesServ', options: () => {return {variables: {}}}}),
  graphql(queries.query.allTipoTec, {name:'allTipoTec', options: () => {return {variables: {}}}}),
)(AddServicio2)
